import React from 'react';
import {Datagrid, Filter, List, TextField, TextInput} from 'react-admin';
import {DateTimeField} from "../../components";

const MessagingLogFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const ArchiveMessageLogList = props => (
    <List filters={<MessagingLogFilter/>} {...props} exporter={false} bulkActions={false}>
        <Datagrid rowClick="edit">
            <TextField source="id"/>
            <DateTimeField source="createdOn" format="DD/MM/YYYY HH:mm:ss"/>
            <TextField source="channel"/>
            <TextField source="customerName"/>
            <TextField source="excerpt"/>
        </Datagrid>
    </List>
);

export default ArchiveMessageLogList
